/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

const getUser = (user, id) => user.find(({ userId }) => userId === id);

export const bindActiveBidUsers = bids => {
  if (bids && bids.activeBids.length) {
    const { users, activeBids } = bids;

    activeBids.forEach(bid => {
      bid.modes?.forEach(mode => {
        if (mode.modeOwnerUserId) {
          mode.modeOwner = getUser(users, mode.modeOwnerUserId);
        }
      });

      if (bid.mainSalesRepUserId) {
        bid.mainSalesRep = getUser(users, bid.mainSalesRepUserId);
      }

      if (bid.bidSubscriberUserIds && bid.bidSubscriberUserIds.length) {
        bid.bidSubscribers = bid.bidSubscriberUserIds.map(userId =>
          getUser(users, userId)
        );
      }

      if (
        bid.truckloadPricingRegionAssignmentUserIds &&
        bid.truckloadPricingRegionAssignmentUserIds.length
      ) {
        bid.truckloadPricingRegionAssignments = bid.truckloadPricingRegionAssignmentUserIds.map(
          userId => getUser(users, userId)
        );
      }
    });
  }
};

export default bindActiveBidUsers;
